import React, { useState } from 'react';
import styles from '../../CardsAndWallets.module.scss';
import { Box, Typography, ButtonBase, Collapse } from '@mui/material';
import { v1 as uuidv1 } from 'uuid';
import { AppAvatar } from '../../../../../components/Avatar';
import { Button } from 'tt-ui-lib/core';
import { DownIcon, UpIcon } from 'tt-ui-lib/icons';

const FAKE_USERS = [
  {
    first_name: 'Brandon',
    last_name: 'Wood',
    wallet_address: uuidv1(),
    avatar: '/images/templates/test-avatar-2.png',
    role: 'individual',
  },
  {
    first_name: 'John',
    last_name: 'Doe',
    wallet_address: uuidv1(),
    avatar: '/images/templates/test-avatar-2.png',
    role: 'individual',
  },
  {
    first_name: 'Lara',
    last_name: 'Croft',
    wallet_address: uuidv1(),
    avatar: '/images/templates/test-avatar-2.png',
    role: 'individual',
  },
  {
    first_name: 'Melissa',
    last_name: 'Collier',
    wallet_address: uuidv1(),
    avatar: '/images/templates/test-avatar-2.png',
    role: 'individual',
  },
  {
    first_name: 'Brandon',
    last_name: 'Wood',
    wallet_address: uuidv1(),
    avatar: '/images/templates/test-avatar-2.png',
    role: 'individual',
  },
  {
    first_name: 'John',
    last_name: 'Doe',
    wallet_address: uuidv1(),
    avatar: '/images/templates/test-avatar-2.png',
    role: 'individual',
  },
  {
    first_name: 'Lara',
    last_name: 'Croft',
    wallet_address: uuidv1(),
    avatar: '/images/templates/test-avatar-2.png',
    role: 'individual',
  },
  {
    first_name: 'Melissa',
    last_name: 'Collier',
    wallet_address: uuidv1(),
    avatar: '/images/templates/test-avatar-2.png',
    role: 'individual',
  },
];

const RequestsForWalletUsage = () => {
  const [walletUsageRequest, setWalletUsageRequest] = useState(FAKE_USERS);
  const [isExpanded, setIsExpanded] = useState(false);

  const handleToggleView = () => {
    setIsExpanded(!isExpanded);
  };

  return (
    <Box className={styles.contentBox}>
      <Typography className={styles.title}>Requests for wallet usage</Typography>
      <Typography className={styles.subtitle}>
        Please note that if you approve the request, the user will have full access to the funds in
        your wallet and will be able to manage it.
      </Typography>
      {walletUsageRequest.length > 0 && (
        <Box className={styles.requestsList}>
          {walletUsageRequest.slice(0, 2).map((user) => (
            <Box key={user.wallet_address} className={styles.user}>
              <AppAvatar
                nav={0}
                size="sm"
                userName={`${user.first_name} ${user.last_name}`}
                src={user.avatar}
                role={user.role}
                isOnline={false}
              />
              <Box className={styles.userInfo}>
                <Typography className={styles.userName}>
                  {user.first_name} {user.last_name}
                </Typography>
                <Typography className={styles.text}>
                  Requesting permission to use wallet.
                </Typography>
                <Typography className={styles.text}>{user.wallet_address}</Typography>
              </Box>
              <Box className={styles.actions}>
                <Button type="primary">Accept</Button>
                <Button type="link" disableRipple>
                  reject
                </Button>
              </Box>
            </Box>
          ))}
          <Collapse in={isExpanded}>
            <Box className={styles.requestsList}>
              {walletUsageRequest.slice(2).map((user) => (
                <Box key={user.wallet_address} className={styles.user}>
                  <AppAvatar
                    nav={0}
                    size="sm"
                    userName={`${user.first_name} ${user.last_name}`}
                    src={user.avatar}
                    role={user.role}
                    isOnline={false}
                  />
                  <Box className={styles.userInfo}>
                    <Typography className={styles.userName}>
                      {user.first_name} {user.last_name}
                    </Typography>
                    <Typography className={styles.text}>
                      Requesting permission to use wallet.
                    </Typography>
                    <Typography className={styles.text}>{user.wallet_address}</Typography>
                  </Box>
                  <Box className={styles.actions}>
                    <Button type="primary">Accept</Button>
                    <Button type="link" disableRipple>
                      reject
                    </Button>
                  </Box>
                </Box>
              ))}
            </Box>
          </Collapse>
        </Box>
      )}
      {walletUsageRequest.length > 2 && (
        <Box className={styles.viewAllBlock}>
          <ButtonBase
            type="link"
            className={styles.viewAllButton}
            onClick={handleToggleView}
            disableRipple
          >
            <Typography className={styles.text}>
              {!isExpanded ? 'View all' : 'View less'}
            </Typography>
            <Box className={styles.downIcon}>{isExpanded ? <UpIcon /> : <DownIcon />}</Box>
          </ButtonBase>
        </Box>
      )}
    </Box>
  );
};

export default RequestsForWalletUsage;
